import type { RouletteSlotProbabilityHint } from '@/lib/rouletteProbabilityBudget'
import styles from './CampanhasPage.module.css'

export interface RoletaSlotProbabilityHintProps {
  id?: string
  hint: RouletteSlotProbabilityHint
  canFillRemainder: boolean
}

export function RoletaSlotProbabilityHint({ id, hint, canFillRemainder }: RoletaSlotProbabilityHintProps) {
  return (
    <div id={id} className={styles.roletaProbSlotHint} aria-live="polite">
      <p>
        <span className={styles.roletaProbSlotHintLabel}>Total geral:</span>{' '}
        <strong>{hint.totalDisplay}%</strong>
        <span className={styles.roletaProbSlotHintSep}> · </span>
        <span className={styles.roletaProbSlotHintLabel}>Nesta posição:</span>{' '}
        <strong>{hint.currentSlotDisplay}%</strong>
      </p>
      <p>
        <span className={styles.roletaProbSlotHintLabel}>Disponível para esta fatia:</span>{' '}
        <strong className={canFillRemainder ? styles.roletaProbSlotHintAvailable : undefined}>
          {hint.availableForPositionDisplay}%
        </strong>
        {canFillRemainder ? (
          <span className={styles.roletaProbSlotHintNote}> (botão &quot;Usar restante&quot;)</span>
        ) : (
          <span className={styles.roletaProbSlotHintNote}>
            {' '}
            — soma das outras fatias: {hint.othersSumDisplay}%
          </span>
        )}
      </p>
    </div>
  )
}
